//BFSG
import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import Link from 'theme/atoms/Link'
import useTranslations from 'hooks/useTranslations'
import usePageContext from 'hooks/usePageContext'

export type Props = {
  recordId: string
}

export default function FilteredCategoriesChips(props: Props) {
  const t = useTranslations<'molecules-ProductList'>()

  const ctx = usePageContext()
  const filteredCategories =
    ctx?.type === 'Category' ? ctx.filteredCategories || [] : []

  if (props.recordId !== 'category' || filteredCategories.length === 0)
    return null
  return (
    <Wrapper
      className="FilteredCategoriesChips"
      data-cy-ctx="molecules/FilteredCategoriesChips"
      data-cy-state="series-show-filtered-categories-chips"
    >
      <div className="chips-headline">{t('filtered_categories_headline')}</div>
      <div className="chips-container">
        {filteredCategories.map((category) => (
          <Link
            key={category.title}
            to={category.urlPath}
            aria-label={t.asText(false, "BFSG_link_to_category", { category: category.title })}
          >
            {category.title}
          </Link>
        ))}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  @media (min-width: ${theme.ms.LG}px) {
    position: static;
  }
  > .chips-headline {
    ${theme.ty('rc-s', '700', 'rc-l')}
    margin-bottom: ${theme.spacing('s')};
  }
  > .chips-container {
    /* Hide scrollbars */
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
    overflow-x: scroll;
    display: flex;
    gap: ${theme.spacing('xs')};
    flex-wrap: nowrap;
    @media (min-width: ${theme.ms.LG}px) {
      position: unset;
      flex-wrap: wrap;
    }
    > a {
      white-space: nowrap;
      &:focus-visible {
        border: 3px solid blue;
      }
      @media (min-width: ${theme.ms.LG}px) {
        white-space: normal;
      }

      padding: ${theme.spacing('xs')} ${theme.spacing('xxs')};
      ${theme.rounding('m')}
      border: 1px solid ${theme.colors.b0};
      background-color: ${theme.colors.white};
      ${theme.ty('rc-s')}
      &:hover {
        background-color: ${theme.colors.shade.b6};
      }
    }
  }
`
